import { useTranslation } from 'react-i18next';
import Dropdown from '../../../../../../../common/widgets/Dropdown';
import { config } from '../../../../../config';
import { CardProductModel } from '../../../../../models/Cards';
import { resources } from '../../../../../resources/resources';

interface ProductSelectorProps {
  products: CardProductModel[];
  selectedProduct?: CardProductModel;
  onProductSelect: (product: CardProductModel) => void;
  usePriceSelector?: boolean;
  areTopUpDetailsLoading?: boolean;
}

export const ProductSelector = (props: ProductSelectorProps) => {
  const {
    products,
    selectedProduct,
    onProductSelect,
    usePriceSelector,
    areTopUpDetailsLoading,
  } = props;
  const { t: translate } = useTranslation();

  if (!products.length) return null;

  const label = usePriceSelector
    ? translate(resources.employeeCards.topUp.meal.ticketPrice)
    : translate(resources.employeeCards.topUp.topUpWith);
  const data = usePriceSelector
    ? products.map(e => ({
        ...e,
        text: `${e.price} ${config.currency}`,
      }))
    : products;
  const value = selectedProduct
    ? data.find(e => e.productId === selectedProduct.productId)
    : undefined;
  const textField = usePriceSelector ? 'text' : 'name';
  const readonlyField = usePriceSelector
    ? `${products[0].price} ${config.currency}`
    : products[0].name;

  return (
    <div className="topup-section pt">
      {products.length > 1 ? (
        <Dropdown
          label={label}
          dataItemKey="productId"
          textField={textField}
          data={data}
          value={value}
          onChange={e => onProductSelect(e.value)}
          mandatory
          disabled={areTopUpDetailsLoading}
        />
      ) : (
        <div className="topup-card-type-title">
          {label}: <b>{readonlyField}</b>
        </div>
      )}
    </div>
  );
};
